module.exports = __webpack_public_path__ + "img/translate.8b79573c.svg";